import Vue from "vue";
import Router from "vue-router";

import SignIn from "@/views/signIn/SignIn.vue";
import SignUp from "@/views/signUp/SignUp.vue";
import Reminder from "@/views/reminder/Reminder.vue";
import Index from "@/views/index/index.vue";
import IndexSignal from "@/views/indexSignal/indexSignal.vue";
import IndexSignalMapping from "@/views/indexSignalMapping/IndexSignalMapping.vue";
import IndexSeatMapping from "@/views/indexSeatMapping/IndexSeatMapping.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/signIn",
      name: "SignIn",
      component: SignIn,
    },
    {
      path: "/signUp",
      name: "SignUp",
      component: SignUp,
    },
    {
      path: "/reminder",
      name: "Reminder",
      component: Reminder,
    },
    {
      path: "/",
      name: "Index",
      component: Index,
    },
    {
      path: "/signalMapping",
      name: "SignalMapping",
      component: IndexSignalMapping,
    },
    {
      path: "/signal",
      name: "Signal",
      component: IndexSignal,
    },
    {
      path: "/seatMapping",
      name: "SeatMapping",
      component: IndexSeatMapping,
    },
    {
      path: "*",
      redirect: {
        name: "SignIn",
      },
    },
  ],
});

router.afterEach((to, from) => {
  const toPath: string = to.path;
  if (toPath !== "/signIn") {
    localStorage.setItem("path", toPath);
  }
});

export default router;
